import { Component, OnInit, AfterContentInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ENavigationErrorType } from './model/enum/navigation-error-type';
import { CoreData } from './tools/core-data/core-data';
import { ENavigationRoute } from './model/enum/navigation-route';

@Component({
    template: `
    <div class="pre d-flex justify-content-center  flex-column p-3" >
        <p class="text-center" style="font-size: 18px;"> {{ErrorMessage}} </p>

        <div class="d-flex justify-content-center">
            @if (ErrorType === ENavigationErrorType.IE) {
                <div>
                    <a href="https://www.google.fr/chrome">Chrome</a><br/>
                    <a href="https://www.mozilla.org/fr/firefox/new">FireFox</a>
                </div>
            }
        </div>
    </div>
    `,
    standalone: true
})
export class ErrorComponent implements OnInit, AfterContentInit {

    ErrorMessage: string = '';
    ErrorType: ENavigationErrorType = ENavigationErrorType.IE;
    ENavigationErrorType = ENavigationErrorType;

    constructor(

        private router: Router,
        private route: ActivatedRoute,
        private coreData: CoreData) { }

    ngOnInit() {
    }

    ngAfterContentInit() {
        this.ErrorType = Number(this.route.snapshot.params['type']) as ENavigationErrorType;
        switch (this.ErrorType) {
            case ENavigationErrorType.IE:
                this.ErrorMessage =
                    `Internet Explorer n'est plus maintenu par Microsoft et n'est plus accepté par les différentes poliques informatiques d'EUROFINS.
                    Merci d'utiliser un navigateur valide afin d'accéder aux differents outils informatiques :`;
                break;
            case ENavigationErrorType.UnAuthorized:
                this.ErrorMessage = `Désolé vous n'avez pas les permissions nécessaires pour accéder à cette page`;
                break;
            // case ENavigationErrorType.MissConfigurationLoop:
            //     this.ErrorMessage = `Un problème de configuration a été detecté. 
            //     Les serveurs ne match pas.
            //     Merci de verifier les adresses des serveurs dans les fichier environment et appSettings`;
            //     break;
            default:
                this.ErrorMessage = `Désolé nous n'avons pas pu trouver la page que vous avez demandé.`;
        }
    }
}
